import React from 'react';
import { Layout, Space, Typography, Button, Dropdown, Avatar, theme } from 'antd';
import { 
  UserOutlined, 
  LogoutOutlined, 
  SettingOutlined,
  BellOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { canEnterOperatorVendorDirectory, canManageAnyTags } from '@/store/vendorAccess';
import { canEnterTransfers } from '@/store/transferAccess';
import BusinessUnitSelector from '@/components/business-unit/BusinessUnitSelector';

const { Header: AntHeader } = Layout;
const { Title, Text } = Typography;

const Header: React.FC = () => {
  const { token } = theme.useToken();
  const { user, authorization, logout } = useAuthStore();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const userMenuItems = [
    {
      key: 'profile',
      label: 'Profile',
      icon: <UserOutlined />,
    },
    {
      key: 'settings',
      label: 'Settings',
      icon: <SettingOutlined />,
    },
    {
      type: 'divider' as const,
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutOutlined />,
      onClick: handleLogout,
    },
  ];

  return (
    <AntHeader 
      style={{ 
        background: '#fff',
        borderBottom: '1px solid #f0f0f0',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Link to="/" style={{ color: token.colorPrimary }}>
          <Title level={4} style={{ margin: 0, color: 'inherit' }}>
            Data Exchange
          </Title>
        </Link>
        <Text type="secondary" style={{ marginLeft: '8px' }}>
          Secure File Transfer
        </Text>
        <Space size="middle" style={{ marginLeft: 24 }}>
          {authorization?.globalAdmin ? (
            <Link to="/vendors">Vendors</Link>
          ) : canEnterOperatorVendorDirectory(authorization) ? (
            <Link to="/my-vendors">Vendors</Link>
          ) : null}
          {canEnterTransfers(authorization) && (
            <Link to="/transfers">Transfers</Link>
          )}
          {authorization?.actions.includes('transfers.adhoc') && (
            <Link to="/transfers/ad-hoc">Ad Hoc Transfer</Link>
          )}
          {(authorization?.globalAdmin || authorization?.actions.includes('settings.manage')) && (
            <Link to="/settings/business-units">Settings</Link>
          )}
          {canManageAnyTags(authorization) && (
            <Link to="/settings/tags">Tags</Link>
          )}
        </Space>
      </div>

      <Space size="middle">
        {user && <BusinessUnitSelector />}
        
        <Button 
          type="text" 
          icon={<BellOutlined />}
          style={{ color: '#8c8c8c' }}
        />
        
        <Button 
          type="text" 
          icon={<QuestionCircleOutlined />}
          style={{ color: '#8c8c8c' }}
        />

        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight" arrow>
          <Space style={{ cursor: 'pointer' }}>
            <Avatar 
              size="small" 
              icon={<UserOutlined />}
              style={{ backgroundColor: token.colorPrimary }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <Text strong style={{ fontSize: '12px', lineHeight: 1 }}>
                {user?.displayName || user?.email || user?.username}
              </Text>
            </div>
          </Space>
        </Dropdown>
      </Space>
    </AntHeader>
  );
};

export default Header;
